export const acceptanceOptions = [
  { label: "Все", value: -1 },
  { label: "Cоздан", value: 0 },
  { label: "Утвержден", value: 1 },
  { label: "Отклонен", value: 2 },
];